$ = require 'jquery'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
templates = require 'app/scripts/views/internal/templates'
{ track } = require '@trello/analytics'
{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = class ComposerLabelSelectorView extends View
  viewTitleKey: 'select labels'
  tagName: 'ul'
  className: 'edit-labels-pop-over'

  events:
    'mouseenter .item': 'hoverLabelSelect'
    'click .card-label': 'addOrRemoveLabel'

  initialize: ->
    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)

  populate: (@populatedLabelList) ->

  render: ->
    view = @
    labels = []

    currentLabels = @model.getLabels()

    labelList = @populatedLabelList ? @model.getBoard().getLabels()

    labels = for label in labelList
      isActive = _.include(currentLabels, label)
      {
        id: label.id
        color: label.get('color')
        name: label.get('name')
        isActive
      }

    data =
      labels: labels

    @$el.html(
      templates.fill(
        'select_labels',
        data
      )
    )

    Util.selectMenuItem(
      @$('.edit-labels-pop-over'),
      '.js-select-label',
      @$('.js-select-label').first()
    )
    @

  hoverLabelSelect: (e) ->
    Util.selectMenuItem(
      @$('.edit-labels-pop-over'),
      '.js-select-label',
      $(e.target).closest('.js-select-label')
    )

  addOrRemoveLabel: (e) ->
    Util.stop(e)
    $label = $(e.target).closest('.js-select-label')
    $label.toggleClass('active')
    idLabel = $label.attr('data-idlabel')
    if @model.toggleLabel(@modelCache.get('Label', idLabel))
      track('Card Composer', 'Add Label')
      # GAS migration cleanup: this is likely dead code
      # https://bitbucket.org/trello/web/pull-requests/5317/
      if @sendGASEvent
        Analytics.sendTrackEvent
          action: 'added'
          actionSubject: 'label'
          source: 'cardComposerLabelSelectorInlineDialog'
    else
      track('Card Composer', 'Remove Label')
      # GAS migration cleanup: this is likely dead code
      # https://bitbucket.org/trello/web/pull-requests/5317/
      if @sendGASEvent
        Analytics.sendTrackEvent
          action: 'removed'
          actionSubject: 'label'
          source: 'cardComposerLabelSelectorInlineDialog'

    return
